// src/socket.js
import { io } from "socket.io-client";

// Replace this with your backend URL
const SOCKET_URL = process.env.REACT_APP_PHONEPE_NODE_URL;

const socket = io(SOCKET_URL, {
  transports: ["websocket"],
  reconnection: true,
});

export default socket;
